import { CommonPopup } from '../commonPopup/commonPopup.component';
import { t } from '../../i18n';

export class CSLLockPopup extends CommonPopup {
  static _template() {
    return {
      ...super._template(),
      title: t('error.csl'),
    };
  }
}
